import { getCurrentUser, initAuth } from '../../../clients/firebase';
const defaultHeaders = {
  'Content-Type': 'application/json',
};

class DefaultService {
  public collection: string;
  protected baseAPI = process.env.REACT_APP_ERP_BACKEND;

  constructor(collection: string) {
    this.collection = collection;
  }
  intercept(url: string, config: any): any {
    const user: any = getCurrentUser();
    if (user && user?.accessToken) {
      // get user session profile from profile service
      let _token = user.accessToken;
      let _config = { ...config }; // shallow copy of the config
      _config.headers = _config.headers || {}; // make sure headers is initialized
      _config.headers['authorization'] = _token;

      return [url, _config];
    } else {
      const firebaseAuth = initAuth();
      firebaseAuth.signOut();
    }
  }

  async fetchJson<T>(endPoint: string, options?: RequestInit): Promise<T> {
    return new Promise((resolve, reject) => {
      const [url, config] = this.intercept(
        `${this.baseAPI}/${this.collection}${endPoint}`,
        {
          ...options,
          headers: {
            ...defaultHeaders,
            ...(options?.headers || {}),
          },
        }
      );
      fetch(url, config)
        .then(res => {
          checkStatusAction(res.status);

          if (res.ok) {
            return res.json();
          } else {
            return res.json().then(err => {
              throw { response: res, message: err.message || 'Unknown error' };
            });
          }
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  async fetchCustomContentType(
    endPoint: string,
    options?: RequestInit
  ): Promise<Response> {
    return new Promise((resolve, reject) => {
      const [url, config] = this.intercept(
        `${this.baseAPI}/${this.collection}${endPoint}`,
        {
          ...options,
          headers: {
            ...defaultHeaders,
            ...(options?.headers || {}),
          },
        }
      );
      fetch(url, config)
        .then(res => {
          checkStatusAction(res.status);
          return res;
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
  async uploadFile(endPoint: string, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);

    return new Promise((resolve, reject) => {
      const [url, config] = this.intercept(
        `${this.baseAPI}/${this.collection}${endPoint}`,
        {
          method: 'POST',
          body: formData,
          // Note: Fetch will set the Content-Type header to 'multipart/form-data' with the appropriate boundary automatically.
        }
      );
      fetch(url, config)
        .then(res => {
          checkStatusAction(res.status);
          if (res.ok) {
            return res.json();
          } else {
            return res.json().then(err => {
              throw { response: res, message: err.message || 'Unknown error' };
            });
          }
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}

function checkStatusAction(status: number) {
  if (status === 401) {
    const firebaseAuth = initAuth();
    firebaseAuth.signOut();
  }
  if (status === 403) {
    window.location.href = window.location.origin + '/packages';
  }
  if (status === 405) {
    window.location.href = window.location.origin + '/integration';
  }
  return;
}

export default DefaultService;
